import React from "react";

const CustomSelect = ({ label = "", dataArray, onSelect, selectedItem }) => {
  return (
    <div className="flex flex-col space-y-2">
      <label className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor">
        {label}
      </label>
      <div className="flex items-center space-x-4">
        {dataArray.map((gender) => (
          <button
            key={gender}
            type="button"
            onClick={() => onSelect(gender)}
            className={`px-[4%] py-[0.5%] rounded-3xl border-2 ${
              selectedItem === gender
                ? "bg-primaryColor border-primaryColor"
                : "bg-accentColor border-accentColor"
            } font-normal text-[4vw] lg:text-[1vw] text-whiteColor`}
          >
            {gender.charAt(0).toUpperCase() + gender.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomSelect;
